/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Regenerated by `npm run cms:sync` from /api/cms/public/hero-slides.
 *
 * One entry per slide, in the server's display order (sort_order, id),
 * including the HIDDEN ones — the page filters them, and an empty list
 * must mean "no slides in the CMS" rather than "the operator hid them".
 *
 * `copy` holds one entry per locale, each already resolved in that
 * script by the server.
 */

import type { HeroSlideEntry } from '@/content/hero-types'

export type { HeroSlideEntry }

export const cmsHeroSlides: HeroSlideEntry[] = [
  {
    "id": 7,
    "sortOrder": 0,
    "isVisible": true,
    "icon": "lucide:rocket",
    "gradientToken": "olive",
    "imagePosition": "center",
    "ctaLink": "https://csp.yada.hk/",
    "imageMediaUuid": "8d02b770-414d-414d-8a05-7de95696d2b9",
    "copy": {
      "zh-Hant": {
        "tag": "升學及職涯",
        "title1": "學校專屬平台，",
        "title2": "一星期起航",
        "text": "CSP 升學及職涯起航平台——以學校品牌為本，一站式升學與職涯導航，最快一星期上線、無需編碼。頭 50 間學校有特別優惠。",
        "cta": "了解 CSP",
        "imageAlt": "香港學生生涯規劃輔導場景"
      },
      "zh-Hans": {
        "tag": "升学及职涯",
        "title1": "学校专属平台，",
        "title2": "一星期起航",
        "text": "CSP 升学及职涯起航平台——以学校品牌为本，一站式升学与职涯导航，最快一星期上线、无需编码。头 50 间学校有特别优惠。",
        "cta": "了解 CSP",
        "imageAlt": "香港学生生涯规划辅导场景"
      },
      "en": {
        "tag": "Admissions & Careers",
        "title1": "A platform built for",
        "title2": "your school",
        "text": "CSP — Career, Study and Platform: a school-branded, one-stop admissions and careers hub. Live in as little as a week, no coding required. Special offer for the first 50 schools.",
        "cta": "Discover CSP",
        "imageAlt": "Hong Kong students in a career-guidance session"
      }
    }
  },
  {
    "id": 5,
    "sortOrder": 10,
    "isVisible": true,
    "icon": "lucide:landmark",
    "gradientToken": "brown",
    "imagePosition": "left",
    "ctaLink": "/products",
    "imageMediaUuid": "fbf3b412-5ac1-4282-bf22-0959d8583583",
    "copy": {
      "zh-Hant": {
        "tag": "國民教育",
        "title1": "四大支柱，",
        "title2": "一站式到位",
        "text": "依據教育局國民教育指引度身設計，聚焦四大核心支柱：憲制秩序、安全與法治；國家歷史與文化認同；現代發展與戰略定位；以及全球視野與國際責任。配合專屬設計的系統，學校可輕鬆開展並持續提升學生國民教育，讓課程規劃、推行與檢視一站式到位，將國民教育自然融入校園日常，成為學生成長的重要養分。",
        "cta": "了解國民教育",
        "imageAlt": "國民教育：盾牌象徵憲制秩序與法治，書本代表國家歷史與文化，四根支柱承托四大核心"
      },
      "zh-Hans": {
        "tag": "国民教育",
        "title1": "四大支柱，",
        "title2": "一站式到位",
        "text": "依据教育局国民教育指引度身设计，聚焦四大核心支柱：宪制秩序、安全与法治；国家历史与文化认同；现代发展与战略定位；以及全球视野与国际责任。配合专属设计的系统，学校可轻松开展并持续提升学生国民教育，让课程规划、推行与检视一站式到位，将国民教育自然融入校园日常，成为学生成长的重要养分。",
        "cta": "了解国民教育",
        "imageAlt": "国民教育：盾牌象征宪制秩序与法治，书本代表国家历史与文化，四根支柱承托四大核心"
      },
      "en": {
        "tag": "National Education",
        "title1": "Four pillars,",
        "title2": "one seamless system",
        "text": "Built to the Education Bureau's national education guidelines, focusing on four core strands: constitutional order, security and rule of law; national history and cultural identity; modern development and strategic positioning; and a global outlook with international responsibility. Schools can launch and continuously strengthen national education, with planning, delivery and review in one place.",
        "cta": "Learn about National Education",
        "imageAlt": "National education: a shield symbolising constitutional order and the rule of law, a book standing for national history and culture, and four pillars carrying the four core strands"
      }
    }
  },
  {
    "id": 6,
    "sortOrder": 20,
    "isVisible": true,
    "icon": "lucide:bot",
    "gradientToken": "greenDark",
    "imagePosition": "right",
    "ctaLink": "/products/smart-cindy",
    "imageMediaUuid": "8d2d859c-8b8d-4b63-902b-965b9032e4a6",
    "copy": {
      "zh-Hant": {
        "tag": "AI 升學及就業顧問",
        "title1": "SmartCindy——",
        "title2": "24 小時的 AI 升學顧問",
        "text": "專為香港 DSE 學生而設的 AI 升學及就業顧問。以 RAG 檢索增強生成技術，即時解答文憑試出路、JUPAS 選科、本地及海外升學問題——答案全部來自經過整理與驗證的知識庫，而不是模型憑空作答。",
        "cta": "了解 SmartCindy",
        "imageAlt": "SmartCindy AI 升學及就業顧問：戴上耳機的學生微笑作答，背景是香港城市天際線與 AI 網絡圖示"
      },
      "zh-Hans": {
        "tag": "AI 升学及就业顾问",
        "title1": "SmartCindy——",
        "title2": "24 小时的 AI 升学顾问",
        "text": "专为香港 DSE 学生而设的 AI 升学及就业顾问。以 RAG 检索增强生成技术，即时解答文凭试出路、JUPAS 选科、本地及海外升学问题——答案全部来自经过整理与验证的知识库，而不是模型凭空作答。",
        "cta": "了解 SmartCindy",
        "imageAlt": "SmartCindy AI 升学及就业顾问：戴上耳机的学生微笑作答，背景是香港城市天际线与 AI 网络图示"
      },
      "en": {
        "tag": "AI Further-Study & Career Advisor",
        "title1": "SmartCindy —",
        "title2": "your 24/7 AI study advisor",
        "text": "An AI further-study and career advisor built for Hong Kong DSE students. Using Retrieval-Augmented Generation (RAG), it answers questions on DSE pathways, JUPAS subject choices and local or overseas study — every answer drawn from a curated, verified knowledge base, never made up by the model.",
        "cta": "Explore SmartCindy",
        "imageAlt": "SmartCindy, the AI pathways and careers advisor: a student in headphones smiling at a question, with the Hong Kong skyline and an AI network diagram behind"
      }
    }
  },
  {
    "id": 1,
    "sortOrder": 30,
    "isVisible": true,
    "icon": "lucide:heart-handshake",
    "gradientToken": "green",
    "imagePosition": "center",
    "ctaLink": "/products/values-incubator",
    "imageMediaUuid": "8439f5a7-6f72-41be-9801-133c3157295a",
    "copy": {
      "zh-Hant": {
        "tag": "品格教育",
        "title1": "讓品格被看見，",
        "title2": "讓成長可量度",
        "text": "品格教育數碼系統 ValuesIncubator+ — 以科學實證為基礎，打造可測量、可持續的價值觀教育系統。建基於成長型思維（Growth Mindset），融入強項為本的正向心理學，讓正向行為成為可教育微時刻。配合並促進家校合作。",
        "cta": "了解 ValuesIncubator+",
        "imageAlt": "ValuesIncubator+ 十五項品格卡：寬恕、合作、好奇、欣賞、勇敢、愛學習、仁慈、創意、毅力、判断、誠實、社交智能、謙遜、感恩、謹慎"
      },
      "zh-Hans": {
        "tag": "品格教育",
        "title1": "让品格被看见，",
        "title2": "让成长可量度",
        "text": "品格教育数码系统 ValuesIncubator+ — 以科学实证为基础，打造可测量、可持续的价值观教育系统。建基于成长型思维（Growth Mindset），融入强项为本的正向心理学，让正向行为成为可教育微时刻。配合并促进家校合作。",
        "cta": "了解 ValuesIncubator+",
        "imageAlt": "ValuesIncubator+ 十五项品格卡：宽恕、合作、好奇、欣赏、勇敢、爱学习、仁慈、创意、毅力、判断、诚实、社交智能、谦逊、感恩、谨慎"
      },
      "en": {
        "tag": "Character Education",
        "title1": "Character seen,",
        "title2": "growth measured",
        "text": "ValuesIncubator+ — a science-based, measurable, sustainable values education system. Built on growth mindset and strengths-based positive psychology, turning positive behaviour into teachable micro-moments, in partnership with families.",
        "cta": "Learn about ValuesIncubator+",
        "imageAlt": "ValuesIncubator+ fifteen character cards: forgiveness, collaboration, curiosity, appreciation, courage, love of learning, kindness, creativity, perseverance, judgement, honesty, social intelligence, humility, gratitude and prudence"
      }
    }
  },
  {
    "id": 3,
    "sortOrder": 40,
    "isVisible": true,
    "icon": "lucide:smartphone",
    "gradientToken": "gold",
    "imagePosition": "left",
    "ctaLink": "/products/bite-learn",
    "imageMediaUuid": "3ddc1e85-8bfd-4049-9df7-f060f1c9eff7",
    "copy": {
      "zh-Hant": {
        "tag": "AI 微學習",
        "title1": "把零碎時間，",
        "title2": "變成有效課室",
        "text": "有效加強學習模式——由過往集中、長時間的資訊接收，逐步轉向短小、碎片化、隨時隨地的學習。令學生的零碎及閒置時間，例如上學途中、等候交通工具或用餐期間，往往未被有效運用。變成有效教室。配合優質的微學習內容，培養持續學習習慣。",
        "cta": "了解 BiteLearn",
        "imageAlt": "AI 微學習：手機自動派發短小微學習單元，把上學途中與用餐等零碎時間變成有效課室"
      },
      "zh-Hans": {
        "tag": "AI 微学习",
        "title1": "把零碎时间，",
        "title2": "变成有效课室",
        "text": "有效加强学习模式——由过往集中、长时间的资讯接收，逐步转向短小、碎片化、随时随地的学习。令学生的零碎及闲置时间，例如上学途中、等候交通工具或用餐期间，往往未被有效运用。变成有效教室。配合优质的微学习内容，培养持续学习习惯。",
        "cta": "了解 BiteLearn",
        "imageAlt": "AI 微学习：手机自动派发短小微学习单元，把上学途中与用餐等零碎时间变成有效课室"
      },
      "en": {
        "tag": "AI Micro-Learning",
        "title1": "Turning idle time",
        "title2": "into real classroom",
        "text": "Learning shifts from long, concentrated sessions to short, fragmented, on-the-go micro-lessons. The gaps between classes — the journey to school, waiting for a bus, a meal break — go unused. BiteLearn turns them into effective learning time, building a lasting study habit.",
        "cta": "Learn about BiteLearn",
        "imageAlt": "AI micro-learning: a phone dispenses short micro-lessons, turning the gaps between classes — the journey to school, a meal break — into effective classroom time"
      }
    }
  },
  {
    "id": 2,
    "sortOrder": 50,
    "isVisible": true,
    "icon": "lucide:megaphone",
    "gradientToken": "olive",
    "imagePosition": "center",
    "ctaLink": "/lectures",
    "imageMediaUuid": "9873a722-d8c5-442a-82c5-df730a686e12",
    "copy": {
      "zh-Hant": {
        "tag": "講座分享",
        "title1": "走進校園，",
        "title2": "把議題帶到面前",
        "text": "具備豐富的教育經驗，對教育科技有深入的認識，並了解青年發展的需要。我們團隊走進香港各中學與社區，將 AI 素養、網絡安全、生涯規劃、科技教育及正向教育家長工作坊等議題，帶到老師、家長與學生面前。直接與我們聯絡。",
        "cta": "預約講座",
        "imageAlt": "講座分享：講者向學校師生講解議題，螢幕上顯示上升的數據圖表"
      },
      "zh-Hans": {
        "tag": "讲座分享",
        "title1": "走进校园，",
        "title2": "把议题带到面前",
        "text": "具备丰富的教育经验，对教育科技有深入的认识，并了解青年发展的需要。我们团队走进香港各中学与社区，将 AI 素养、网络安全、生涯规划、科技教育及正向教育家长工作坊等议题，带到老师、家长与学生面前。直接与我们联络。",
        "cta": "预约讲座",
        "imageAlt": "讲座分享：讲者向学校师生讲解议题，萤幕上显示上升的数据图表"
      },
      "en": {
        "tag": "Talks & Workshops",
        "title1": "Into the school,",
        "title2": "face to face",
        "text": "Our team brings years of education experience, deep edtech knowledge and real insight into youth development into Hong Kong schools and communities — running sessions on AI literacy, cyber safety, career planning, technology education and positive-education parent workshops for teachers, parents and students. Get in touch to book one.",
        "cta": "Book a Talk",
        "imageAlt": "Talks and workshops: a speaker addresses teachers and students in a school hall, with a rising data chart on the screen behind"
      }
    }
  },
  {
    "id": 4,
    "sortOrder": 60,
    "isVisible": false,
    "icon": "lucide:compass",
    "gradientToken": "coffee",
    "imagePosition": "center",
    "ctaLink": "/products",
    "imageMediaUuid": "0e36ef9e-f14f-405a-bb49-ea1b13f29931",
    "copy": {
      "zh-Hant": {
        "tag": "AI 升學資訊",
        "title1": "升學資訊零散，",
        "title2": "我們幫你更新",
        "text": "升學資訊零散，容易過時。YADA 專為香港中學度身打造，資料準確且本地化升學資訊平台，透過 AI RAG 技術提供 JUPAS 及八大院校學科資訊，海外及內地升學資訊等，系統定期更新數據，全天候提供服務。",
        "cta": "了解升學平台",
        "imageAlt": "AI 升學資訊：搜尋本地升學資料，JUPAS 及八大院校資訊定期更新、全天候提供"
      },
      "zh-Hans": {
        "tag": "AI 升学资讯",
        "title1": "升学资讯零散，",
        "title2": "我们帮你更新",
        "text": "升学资讯零散，容易过时。YADA 专为香港中学度身打造，资料准确且本地化升学资讯平台，透过 AI RAG 技术提供 JUPAS 及八大院校学科资讯，海外及内地升学资讯等，系统定期更新数据，全天候提供服务。",
        "cta": "了解升学平台",
        "imageAlt": "AI 升学资讯：搜寻本地升学资料，JUPAS 及八大院校资讯定期更新、全天候提供"
      },
      "en": {
        "tag": "AI Pathways Info",
        "title1": "Scattered, stale advice,",
        "title2": "we keep it current",
        "text": "Pathway information is scattered and quickly goes out of date. YADA runs an accurate, localised platform built for Hong Kong secondary schools — AI RAG covering JUPAS and the eight universities, subject information, overseas and mainland routes, refreshed on a schedule and available around the clock.",
        "cta": "Learn about the Platform",
        "imageAlt": "AI pathways information: a compass beside a search panel, with JUPAS and the eight universities’ information refreshed on a schedule and available around the clock"
      }
    }
  }
]
